export default __webpack_public_path__ + "static/media/childDevelopment-blob2.295f9c8a.svg";